
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"39.988"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.985 0a.952.952 0 00-.138.014H.013v7.454a.952.952 0 000 .31v6.352a.952.952 0 000 .31v7.464H19.84a.952.952 0 00.31 0h19.837V14.45a.952.952 0 000-.31V7.787a.952.952 0 000-.31V.014H20.146A.952.952 0 0019.985 0zM1.913 1.914h17.135v4.759H1.913zm19.035 0h17.135v4.759H20.951zM1.913 8.579h17.135v4.759H1.913zm19.035 0h17.135v4.759H20.951zM1.913 15.242h17.135v4.759H1.913zm19.035 0h17.135v4.759H20.951zM7.627 24.365l-4.48 4.48a.952.952 0 101.346 1.346l2.182-2.183v4.366a5.7 5.7 0 01-5.711 5.71.952.952 0 100 1.9 7.629 7.629 0 007.614-7.614v-4.361l2.182 2.182a.952.952 0 101.346-1.346zm12.373 0l-4.48 4.48a.952.952 0 101.346 1.346l2.182-2.183v11.028a.952.952 0 101.9 0V28.009l2.182 2.182a.952.952 0 101.346-1.346zm12.373 0l-4.48 4.48a.952.952 0 101.346 1.346l2.182-2.183v4.366a7.629 7.629 0 007.614 7.614.952.952 0 100-1.9 5.7 5.7 0 01-5.711-5.711v-4.368l2.182 2.182a.952.952 0 101.346-1.346z","fill":"#38470b"}})])
          )
        }
      }
    